export default {
    fields: {
        address: {
            label: 'Адрес',
            placeholder: 'Введите ваш адрес',
        },
        city: {
            label: 'Город',
            placeholder: 'Выберите город',
        },
        country: {
            label: 'Страна',
            placeholder: 'Страна',
        },
        phone: {
            label: 'Телефон',
            placeholder: '+3811231231',
        },
        email: {
            label: 'Email',
            placeholder: "company{'@'}myemail.com",
        },
        type: {
            label: 'Тип',
            placeholder: 'Выберите тип',
        },
    },
    business: 'Филияла',
    parking: 'Стоянка',
}
